import actions from "./action";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";

export const MEMBER_STORE = "manageMember";

export default {
  namespaced: true,

  state,

  actions,

  getters,

  mutations,
};
